import {defaultConfiguration, defaultConfigurationHeader, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_FRONERI: IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'froneri',
  start_page: 'orders',
  language: {
    defaultLang: 'ru',
    showLang: false,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  header:{
    ...defaultConfigurationHeader,
    goLandingSite: 'https://froneri-start.redfactory.io/'
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login: {
      ...defaultConfigurationModules.login,

      loginType: 'common',
      goFAQ: 'https://froneri.redfactory.io/img/FAQ.pdf',
      supportEmail: 'support@redfactory.io',
      enableSelfRegistration: true,
      enableGoogleSignIn: false,
      showTutorialVideo: true,
      showTryDemoButton: true,
      showAboutUsButton: true,
      showContacts: true,
      showContactOnlyEmail: true,

      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main: {
      showSupportBlock: false,
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showPaymentDelay: true,
      showAddressForPartner: true,
    }
  }
};
export const CONFIGURATION_FRONERI_DEV:IConfiguration = {
  ...CONFIGURATION_FRONERI
};
export const CONFIGURATION_FRONERI_PROD:IConfiguration = {
  ...CONFIGURATION_FRONERI
};
